/* tslint:disable */
/* eslint-disable */
/**
 * DevourPlay OpenAPI (Swagger) Documentation
 * This is the API documentation generated from the swagger comments in the backend. These correspond directly to the client library.
 *
 * The version of the OpenAPI document: N/A
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface OWGameSEO
 */
export interface OWGameSEO {
    /**
     * Whether SEO is enabled for this game
     * @type {boolean}
     * @memberof OWGameSEO
     */
    enabled?: boolean;
    /**
     * SEO meta title
     * @type {string}
     * @memberof OWGameSEO
     */
    metaTitle?: string;
    /**
     * SEO meta description
     * @type {string}
     * @memberof OWGameSEO
     */
    metaDescription?: string;
    /**
     * SEO keywords
     * @type {Array<string>}
     * @memberof OWGameSEO
     */
    keywords?: Array<string>;
    /**
     * Open Graph title for social sharing
     * @type {string}
     * @memberof OWGameSEO
     */
    ogTitle?: string;
    /**
     * Open Graph description for social sharing
     * @type {string}
     * @memberof OWGameSEO
     */
    ogDescription?: string;
    /**
     * Open Graph image URL (should use CDN URL)
     * @type {string}
     * @memberof OWGameSEO
     */
    ogImage?: string;
    /**
     * Twitter card type (summary_large_image)
     * @type {string}
     * @memberof OWGameSEO
     */
    twitterCard?: string;
    /**
     * Twitter title for sharing
     * @type {string}
     * @memberof OWGameSEO
     */
    twitterTitle?: string;
    /**
     * Twitter description for sharing
     * @type {string}
     * @memberof OWGameSEO
     */
    twitterDescription?: string;
    /**
     * Twitter image URL (should use CDN URL)
     * @type {string}
     * @memberof OWGameSEO
     */
    twitterImage?: string;
}

export function OWGameSEOFromJSON(json: any): OWGameSEO {
    return OWGameSEOFromJSONTyped(json, false);
}

export function OWGameSEOFromJSONTyped(json: any, ignoreDiscriminator: boolean): OWGameSEO {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'enabled': !exists(json, 'enabled') ? undefined : json['enabled'],
        'metaTitle': !exists(json, 'metaTitle') ? undefined : json['metaTitle'],
        'metaDescription': !exists(json, 'metaDescription') ? undefined : json['metaDescription'],
        'keywords': !exists(json, 'keywords') ? undefined : json['keywords'],
        'ogTitle': !exists(json, 'ogTitle') ? undefined : json['ogTitle'],
        'ogDescription': !exists(json, 'ogDescription') ? undefined : json['ogDescription'],
        'ogImage': !exists(json, 'ogImage') ? undefined : json['ogImage'],
        'twitterCard': !exists(json, 'twitterCard') ? undefined : json['twitterCard'],
        'twitterTitle': !exists(json, 'twitterTitle') ? undefined : json['twitterTitle'],
        'twitterDescription': !exists(json, 'twitterDescription') ? undefined : json['twitterDescription'],
        'twitterImage': !exists(json, 'twitterImage') ? undefined : json['twitterImage'],
    };
}

export function OWGameSEOToJSON(value?: OWGameSEO | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'enabled': value.enabled,
        'metaTitle': value.metaTitle,
        'metaDescription': value.metaDescription,
        'keywords': value.keywords,
        'ogTitle': value.ogTitle,
        'ogDescription': value.ogDescription,
        'ogImage': value.ogImage,
        'twitterCard': value.twitterCard,
        'twitterTitle': value.twitterTitle,
        'twitterDescription': value.twitterDescription,
        'twitterImage': value.twitterImage,
    };
}


